import React, { FC } from 'react';
import styled from 'styled-components';
import HeaderWithChildrenWrapper from 'shared/components/molecules/HeaderWithChildrenWrapper';
import LinkButton from 'shared/components/atoms/LinkButton';
import { ButtonMainStyle } from 'shared/components/atoms/Button';
import { ceaseList, submitCease } from 'CustomerRequests/routes';
import { pages, useTrackPage } from 'shared/utils/trackPage';
import { Link } from 'react-router-dom';

export const CustomerRequestsLanding: FC = () => {
  useTrackPage(pages.requests);

  return (
    <HeaderWithChildrenWrapper header="Requests">
      <Container>
        <div className="d-flex align-items-start justify-content-between flex-wrap gap-2 mb-3">
          <h2 className="h3 mb-0">Customer requests</h2>
          <Link className="faq-link" to="/faq">
            Help & FAQs
          </Link>
        </div>
        <div className="card">
          <div className="card-body">
            <h3 className="h4 mb-2">Cease requests</h3>
            <p className="text-muted mb-3">Manage the cessation of an existing service.</p>
            <div className="actions">
              <LinkButton pathname={submitCease} buttonText="Submit cease request" mainStyle={ButtonMainStyle.PrimaryRectangular} />
              <LinkButton pathname={ceaseList} buttonText="View cease requests" mainStyle={ButtonMainStyle.PrimaryOutline} />
            </div>
          </div>
        </div>
      </Container>
    </HeaderWithChildrenWrapper>
  );
};

const Container = styled.div`
  .card {
  }

  .faq-link {
    white-space: nowrap;
  }

  .actions {
    display: grid;
    gap: 12px;
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  }

  .actions > a {
    width: 100%;
  }

  .actions button.primaryRectangular,
  .actions button.primaryOutline {
    width: 100%;
  }
`;

export default CustomerRequestsLanding;
